<template>
  <div class="u-pad">
    <GameStart />
  </div>
</template>

<script>
import GameStart from "@/components/GameStart.vue";

export default {
  components: {
    GameStart
  }
};
</script>

